import { useState } from 'react';

async function submitContact(form: HTMLFormElement) {
  const data = Object.fromEntries(new FormData(form).entries());
  const payload = {
    full_name: String(data.full_name || '').trim(),
    company_name: String(data.company_name || '').trim(),
    email: String(data.email || '').trim(),
    phone: String(data.phone || '').trim(),
    city: String(data.city || '').trim(),
    business_type: String(data.business_type || '').trim(),
    interested_module: 'İletişim formu',
    message: String(data.message || '').trim(),
    website: String(data.website || '').trim(),
    source_page: window.location.href,
    lead_type: 'contact',
  };
  const res = await fetch('/api/public/website-leads', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let msg = 'Mesaj gönderilemedi. Lütfen tekrar deneyin.';
    try {
      const body = await res.json();
      msg = body.detail || body.message || msg;
    } catch {
      // Keep the safe default message when the API body is not JSON.
    }
    throw new Error(msg);
  }
}

export default function ContactSection() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await submitContact(e.currentTarget);
      setFormSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Mesaj gönderilemedi.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="iletisim" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">Bize Ulaşın</h2>
          <p className="text-foreground-600 text-base md:text-lg">CiftlikWeb hakkında sorularınız mı var? Demo veya bilgi talebinizi bırakın, panelimize düşsün.</p>
        </div>

        {formSubmitted ? (
          <div className="bg-primary-50 border border-primary-200 rounded-xl p-8 text-center">
            <div className="w-14 h-14 mx-auto flex items-center justify-center bg-primary-100 rounded-full mb-4"><i className="ri-check-line text-primary-500 text-2xl"></i></div>
            <h3 className="font-heading font-semibold text-xl text-foreground-950 mb-2">Mesajınız alındı!</h3>
            <p className="text-foreground-600">En kısa sürede size dönüş yapacağız. Teşekkür ederiz.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
            <input type="text" name="website" tabIndex={-1} autoComplete="off" className="hidden" aria-hidden="true" />
            {error && <div className="mb-5 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-6">
              <Field id="contact-ad" name="full_name" label="Ad Soyad" required placeholder="Adınız ve soyadınız" />
              <Field id="contact-firma" name="company_name" label="Firma Adı" placeholder="İşletmenizin adı" />
              <Field id="contact-email" name="email" label="E-posta" type="email" placeholder="ornek@firma.com" />
              <Field id="contact-telefon" name="phone" label="Telefon" type="tel" required placeholder="05XX XXX XX XX" />
              <Field id="contact-sehir" name="city" label="Şehir" placeholder="Şehir" />
              <Field id="contact-tur" name="business_type" label="İşletme Türü" placeholder="Kurbanlık, adaklık, çiftlik..." />
            </div>
            <div className="mb-6">
              <label htmlFor="contact-mesaj" className="block text-sm font-medium text-foreground-700 mb-1.5">Mesajınız</label>
              <textarea id="contact-mesaj" name="message" rows={4} maxLength={800} required className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-md text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all resize-none" placeholder="Sorunuzu veya talebinizi yazın..."></textarea>
            </div>
            <button type="submit" disabled={submitting} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-md hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap disabled:opacity-60">
              {submitting ? 'Gönderiliyor...' : 'Gönder'}
              <i className="ri-send-plane-line text-lg"></i>
            </button>
          </form>
        )}
      </div>
    </section>
  );
}

function Field({ id, name, label, type = 'text', required, placeholder }: { id: string; name: string; label: string; type?: string; required?: boolean; placeholder?: string }) {
  return <div><label htmlFor={id} className="block text-sm font-medium text-foreground-700 mb-1.5">{label}</label><input id={id} name={name} type={type} required={required} className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-md text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all" placeholder={placeholder} /></div>;
}
